/**
 * Validate a string as a phone number without a leading country code
 *   e.g. 415 690 8264
 */
function isValidPhoneNumber(phoneNumber) {
  return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(phoneNumber);
}

export { isValidPhoneNumber };
//# sourceMappingURL=phone.js.map
